import { ApiSuccess, IApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { Base } from "ui/Scripts/source/framework/base";
import { TaskList } from "../task/taskList";
import { TaskEdit } from "../task/taskEdit";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { UserListItem } from "../user/userListItem";
import { postApiCall, getApiCall, postEndlessListApiCall, getFileApiCall } from "./tokenService";
import { UnlockResult } from "../common/unlockResult";
import { TaskDataRowEdit } from "ui/Scripts/source/models/task/taskDataRowEdit";
import { TaskDataRowList } from "../task/taskDataRowList";
import { TaskDataRowDefaultValues } from "ui/Scripts/source/models/task/taskDataRowDefaultValues";
import { TaskStates } from "../task/taskStates";

export interface ISaveTaskSuccess extends IApiSuccess {
    id: string;
    notifications: string;
}

export class SaveTaskSuccess implements ISaveTaskSuccess {
    id: string;
    message: string;
    errorMessage: string;
    notifications: string;

    constructor();
    constructor(obj: ISaveTaskSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.message = obj && obj.message || "";
        this.errorMessage = obj && obj.errorMessage || "";
        this.notifications = obj && obj.notifications || "";
    }
}

export const getTaskList = (page: number, stateId: string, unitId: string): Promise<TaskList> => {
    return getApiCall<TaskList>("api/task?page=" + page +
        "&stateId=" + (!Base.isNullOrUndefined(stateId) ? stateId : "") +
        "&unitId=" + (!Base.isNullOrUndefined(unitId) ? unitId : ""), TaskList);
};

export const taskListRefresh = (page: number, stateId: string, unitId: string): Promise<TaskList> => {
    return getApiCall<TaskList>("api/task/refresh?page=" + page +
        "&stateId=" + (!Base.isNullOrUndefined(stateId) ? stateId : "") +
        "&unitId=" + (!Base.isNullOrUndefined(unitId) ? unitId : ""), TaskList);
};

export const getUsedTaskStates = (unitId: string): Promise<TaskStates> => {
    return getApiCall("api/task/usedtaskstates?unitId=" + unitId, TaskStates);
};

export const getTaskEdit = (id: string): Promise<TaskEdit> => {
    return getApiCall<TaskEdit>("api/task/item?id=" + id, TaskEdit);
};

export const saveTask = (obj: any): Promise<SaveTaskSuccess> => {
    return postApiCall<SaveTaskSuccess>("api/task/save", SaveTaskSuccess, JSON.stringify(obj));
};

export const emailTask = (id: string, notifications: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/task/email", ApiSuccess,
        JSON.stringify({ id, notifications }));
};

export const moveToTrash = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/task/movetotrash?id=" + id, ApiSuccess);
};

export const restoreFromTrash = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/task/restorefromtrash?id=" + id, ApiSuccess);
};

export const printTask = (id: string, name: string, rowAmount: number): Promise<string> => {
    return getFileApiCall("api/task/print?id=" + id + "&name=" + name + "&rowAmount=" + rowAmount.toString(10));
};

export const getUserList = (taskId: string, unitId: string, page: number, ignoreUserCodes: string[]): Promise<IEndlessList<UserListItem>> => {
    return postEndlessListApiCall<UserListItem>("api/task/user", UserListItem,
        JSON.stringify({ taskId, unitId, page, ignoreUserCodes }));
};

export const getLocked = (id: string): Promise<boolean> => {
    return getApiCall<boolean>("api/task/getlocked?id=" + id, null);
};

export const unlock = (id: string, lockToCurrentUser: boolean): Promise<UnlockResult> => {
    return postApiCall<UnlockResult>("api/task/unlock?id=" + id +
        "&lockToCurrentUser=" + (lockToCurrentUser ? "true" : "false"), UnlockResult);
};

export interface ISavedId {
    oldId: string;
    newId: string;
}

export class SavedId implements ISavedId {
    oldId: string;
    newId: string;

    constructor();
    constructor(obj: ISavedId);
    constructor(obj?: any) {
        this.oldId = obj && obj.oldId || "";
        this.newId = obj && obj.newId || "";
    }
}

export interface ISaveTaskDataRowSuccess extends IApiSuccess {
    id: string;
    savedAttachmentsIds: ISavedId[];
}

export class SaveTaskDataRowSuccess implements ISaveTaskDataRowSuccess {
    id: string;
    message: string;
    errorMessage: string;
    savedAttachmentsIds: SavedId[];

    constructor();
    constructor(obj: ISaveTaskSuccess);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.message = obj && obj.message || "";
        this.errorMessage = obj && obj.errorMessage || "";
        this.savedAttachmentsIds = Base.getTypedArray<SavedId>(obj ? obj.savedAttachmentsIds : null, SavedId);
    }
}

// #region TaskDataRows
export const getTaskDataRowList = (taskId: string, pageSize: number, page: number): Promise<TaskDataRowList> => {
    return getApiCall<TaskDataRowList>("api/taskdatarow/list?id=" + taskId + "&pageSize=" + pageSize + "&page=" + page, TaskDataRowList);
};

export const getTaskDataRowDefaultValues = (taskId: string): Promise<TaskDataRowDefaultValues> => {
    return getApiCall("api/taskdatarow/new/defaultvalues?taskId=" + taskId, TaskDataRowDefaultValues);
};

export const getTaskDataRowEdit = (taskId: string, id: string): Promise<TaskDataRowEdit> => {
    return getApiCall<TaskDataRowEdit>("api/taskdatarow/item?id=" + id + "&taskId=" + taskId, TaskDataRowEdit);
};

export const saveTaskDataRow = (obj: any): Promise<SaveTaskDataRowSuccess> => {
    return postApiCall<SaveTaskDataRowSuccess>("api/taskdatarow/save", SaveTaskDataRowSuccess, JSON.stringify(obj));
};

export const unlockTaskDataRow = (taskId: string, id: string, lockToCurrentUser: boolean): Promise<UnlockResult> => {
    return postApiCall<UnlockResult>("api/taskdatarow/unlock?id=" + id +
        "&taskId=" + taskId +
        "&lockToCurrentUser=" + (lockToCurrentUser ? "true" : "false"), UnlockResult);
};

export const removeTaskDataRow = (taskId: string, id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/taskdatarow/remove?id=" + id + "&taskId=" + taskId, ApiSuccess);
};
// #endregion TaskDataRows
